import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IProductsResponse } from '../models/products.model';
import { fromStaticDataProductNamesAction } from '../actions';

export const productsFeatureKey = 'products';

export interface ProductsState {
  products: IProductsResponse[];
  productsFailure: IGenericError<ErrorResponse>;
}

export const initialState: ProductsState = {
  products: undefined,
  productsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromStaticDataProductNamesAction.loadProductsSuccess, (state, action) => ({
    ...state,
    products: action.response
  })),

  on(fromStaticDataProductNamesAction.loadProductsFailure, (state, action) => ({
    ...state,
    productsFailure: action.error
  }))
);

export const getProductNamesResponse = (state: ProductsState) => state.products;
export const getProductNamesFailure = (state: ProductsState) => state.productsFailure;
